import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  createGiftCode,
  deleteGiftCode,
  getAllGiftCodes,
  getGiftCodeById,
  giftcodeActiveInactive,
  giftCodeLedger,
  updateGiftCode,
} from "./services/giftcode.services";
import { IGiftCode, IGiftCodeInitialState } from "./giftcodeModel";

const initialState: IGiftCodeInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  GiftCodeList: [],
  GiftCodeID: null,
  GiftCodeDetail: {
    ID: null,
    GiftCode: "",
    FromDate: "",
    ToDate: "",
    Amount: 0,
    UsageCount: 1,
    MinAmtUsage: 0,
    MaxAmtUsage: 0,
    AmountType: "RS",
    FlightTicketAmt: 0,
    HotelBookingAmt: 0,
    UsableAmount: 0,
    IsAuto: true,
    OnlyUsedInWallet: false,
    Type: "Auto",
    IsActive: 1,
  },
  GiftCodeLedgerDetails: {
    FromDate: "",
    ToDate: "",
    AssignUserID: null,
    AssignUser: "",
    MobileNo: "",
    UsageCount: 0,
    MinAmtUsage: 0,
    MaxAmtUsage: 0,
    FlightTicketAmt: 0,
    HotelBookingAmt: 0,
    PendingAmt: 0,
    Amount: 0,
    OnlyUsedInWallet: false,
    GiftCodeLedgerDetail: [],
  },
};

const giftcodeSlice = createSlice({
  name: "giftcode",
  initialState,
  reducers: {
    clearGiftCodeDetails: (state) => {
      state.GiftCodeDetail = initialState.GiftCodeDetail;
    },
    clearGiftCodeLedgerDetails: (state) => {
      state.GiftCodeLedgerDetails = initialState.GiftCodeLedgerDetails;
    },
    setGiftCodeID: (state, action) => {
      state.GiftCodeID = action.payload;
    },
    clearGiftCodeID: (state) => {
      state.GiftCodeID = initialState.GiftCodeID;
    },
  },
  extraReducers: (builder) => {
    /* For getAll Cities */
    builder.addCase(getAllGiftCodes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllGiftCodes.fulfilled,
      (state, action: PayloadAction<IGiftCode[]>) => {
        state.loading = false;
        state.GiftCodeList = action.payload || [];
      }
    );
    builder.addCase(getAllGiftCodes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.GiftCodeList = [];
    });

    /* For getGiftCodeBy ID */
    builder.addCase(getGiftCodeById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getGiftCodeById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.GiftCodeDetail = action.payload;
    });
    builder.addCase(getGiftCodeById.rejected, (state, action) => {
      state.formLoading = false;
      state.GiftCodeDetail = initialState.GiftCodeDetail;
      state.error = action.error.message || "Something went wrong";
    });

    /* For getGiftCodeLedger ID */
    builder.addCase(giftCodeLedger.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(giftCodeLedger.fulfilled, (state, action: any) => {
      state.loading = false;
      state.GiftCodeLedgerDetails = action.payload;
    });
    builder.addCase(giftCodeLedger.rejected, (state, action) => {
      state.loading = false;
      state.GiftCodeLedgerDetails = initialState.GiftCodeLedgerDetails;
      state.error = action.error.message || "Something went wrong";
    });

    /* For create GiftCode */
    builder.addCase(createGiftCode.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createGiftCode.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createGiftCode.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For Update GiftCode */
    builder.addCase(updateGiftCode.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateGiftCode.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateGiftCode.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For Delete Cities */
    builder.addCase(deleteGiftCode.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteGiftCode.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteGiftCode.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For GiftCodeActiveInactive */
    builder.addCase(giftcodeActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(giftcodeActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(giftcodeActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearGiftCodeID,
  clearGiftCodeDetails,
  clearGiftCodeLedgerDetails,
  setGiftCodeID,
} = giftcodeSlice.actions;
export default giftcodeSlice.reducer;
